module.exports = __webpack_public_path__ + "img/pic_dianfanbao3.e48bd2f8.png";